import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '首页', path: '/' },
      { label: '注册登录', path: '/category/register-login' },
      { label: '功能使用', path: '/category/feature-guide' },
      { label: '常见问题', path: '/category/faq' },
    ],
  },
  {
    title: '平台服务',
    links: [
      { label: '平台公告', path: '/category/announcement' },
      { label: '安全指南', path: '/category/security' },
      { label: '关于我们', path: '/about' },
    ],
  },
  {
    title: '联系方式',
    links: [
      { label: '联系客服', path: '/about' },
      { label: '意见反馈', path: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="text-xl font-bold text-background-50 font-heading whitespace-nowrap">
              91n.com
            </Link>
            <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
              值得信赖的网络综合服务平台，提供官方入口、核心功能指南、使用教程及常见问题解答。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">{group.title}</h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2018-2026 91n.com 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <span>support@91n.com</span>
            <Link to="/about" className="hover:text-background-50 transition-colors">关于我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}